import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class CreateEventCoverCommand implements IMessage {
    eventId!: Guid;
    mimeType!: string;
    content!: string;

    public constructor(init?: Partial<CreateEventCoverCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "POST";

    getUrl = () => `/admin/events/${this.eventId.toString()}/cover`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            mimeType: this.mimeType,
            content: this.content,
        };
    }
}